import { Component, Input } from "@angular/core";

@Component({
	selector: "app-link-to-youtube",
	templateUrl: "./link-to-youtube.component.html",
	styleUrls: ["./link-to-youtube.component.scss"]
})
export class LinkToYoutubeComponent {
	@Input()
	url: string = "";
	@Input()
	name: string = "Charametrics";
	@Input()
	hideText = false;
}
